import styled from "styled-components";

export const StyledFormField = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  & .error {
    margin-top: 2px;
    min-height: 24px;
  }
`;
